/**
 * @file schemas.ts
 * @brief Zod schemas for home-screen promotional banners.
 *
 * @details
 * Mirrors the `banners` table and the admin API payloads consumed by
 * the mobile Super Admin tab and the web panel Home Ads page.
 *
 * @references
 * - BACKEND/src/features/banners/service.js
 * - FRONTEND/src/shared/hooks/useAdmin.ts (AdminBanner)
 *
 * @author DES
 * @date 07-06-2026
 */

import { z } from "zod";

export const BannerSchema = z.object({
  id: z.string(),
  image_url: z.string(),
  title: z.string().nullable().optional(),
  subtitle: z.string().nullable().optional(),
  cta_text: z.string().nullable().optional(),
  target_route: z.string().nullable().optional(),
  is_enabled: z.boolean(),
  display_order: z.coerce.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Banner = z.infer<typeof BannerSchema>;

export const BannersListSchema = z.array(BannerSchema);

export const BannerInputSchema = z.object({
  image_url: z.string().min(1, "Banner image is required"),
  title: z.string().max(60).optional(),
  subtitle: z.string().max(100).optional(),
  cta_text: z.string().max(20).optional(),
  target_route: z.string().optional(),
  is_enabled: z.boolean(),
  display_order: z.coerce.number().int().min(0),
});

export type BannerInput = z.infer<typeof BannerInputSchema>;
